// Imagens da Gi Inovações otimizadas para web.
// Cada item aponta para o arquivo WebP em /public/assets/factory/.
//
// Para adicionar mais fotos:
//   1) Rode: python3 /app/scripts/optimize-images.py /caminho/das/fotos
//   2) Adicione os novos arquivos abaixo (img-02, img-03 etc.)
//
// O navegador faz fallback automático para .jpg se WebP não estiver disponível
// (vide elemento <picture> em components/MouseTrail.jsx).
export const FACTORY_IMAGES = [
  "/assets/solucoes/1.jpg",
  "/assets/solucoes/2.jpg",
  "/assets/solucoes/3.jpg",
  "/assets/solucoes/4.jpg",
  "/assets/solucoes/5.jpg",
  "/assets/solucoes/6.jpg",
  "/assets/factory/img-01.webp",
  "/assets/factory/img-02.webp",
  "/assets/factory/img-03.webp",
  "/assets/factory/img-04.webp",
  "/assets/factory/img-05.webp",
  "/assets/factory/img-06.webp",
  "/assets/factory/img-07.webp",
  "/assets/factory/img-08.webp",
  "/assets/factory/img-09.webp",
];

// Imagens panorâmicas (16:10) para hero, banners e cards.
export const FACTORY_WIDE = [
  "/assets/factory/img-01-wide.webp",
  "/assets/factory/img-02-wide.webp",
  "/assets/factory/img-03-wide.webp",
  "/assets/factory/img-04-wide.webp",
  "/assets/factory/img-05-wide.webp",
  "/assets/factory/img-06-wide.webp",
  "/assets/factory/img-07-wide.webp",
  "/assets/factory/img-08-wide.webp",
  "/assets/factory/img-09-wide.webp",
];
